import { Type } from '@angular/core';
import { DateUtils } from '../../date';
import { FormMappingModel } from '../models/form-mapping-model';

export type ParseFunction<T> = (value: any, o: T) => any;

export function ArrayParseFunction<T extends FormMappingModel>(FormModel: Type<T>): (value: T[]) => any {
  return (value) => value.map(DefaultParseFunction(FormModel));
}

export function DefaultParseFunction<T extends FormMappingModel>(FormModel: Type<T>): (value) => any {
  return (value) => FormModel.prototype.from(value);
}

export const NgbDateParseFunction: ParseFunction<any> = (value) => {
  return value != null ? DateUtils.parseToNgbDate(value) : value;
};
